<template>
    <section id="error_main" class="section_padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                    <div class="error_content text-center">
                        <img src="@/assets/img/404.svg" alt="img" style="width: 80%;">
                        <!-- <h2>Error 404 : page not found</h2> -->
                        <!-- <router-link to="tour-details" class="btn btn_theme btn_md" @click="BackHome" id="btn_back">{{ $t('labels.back_home') }}</router-link> -->
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
<script>

export default {
    name: "ErrorArea",
    methods: {
        BackHome() {
            this.$router.go('/tour-details')
        }
    }
};
</script>

<style scoped>
    .section_padding{
        padding: 0!important;
    }
    #btn_back{
        margin-top: 0!important;
        margin-bottom: 10px!important;
    }
</style>